// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { DAMAGE_CASE_ADD_PICTURE } from "./constants"
import { MAX_PICTURES } from "../PicturesPage"
import * as Screens from "../screens"

export function addPicture(caseId, base64, timestamp) {
  return {
    type: DAMAGE_CASE_ADD_PICTURE,
    data: { caseId, base64, timestamp },
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case DAMAGE_CASE_ADD_PICTURE:
      const { caseId, base64, timestamp } = action.data
      const damageCase = state.unsentCases[caseId]
      const newPicture = { base64, timestamp }
      const pictures =
        damageCase.pictures.length < MAX_PICTURES ? [...damageCase.pictures, newPicture] : damageCase.pictures
      const alteredCase = { ...damageCase, pictures }
      return {
        ...state,
        screen: pictures.length === MAX_PICTURES ? Screens.PICTURES_SHOW : state.screen,
        focusedPictureNr: pictures.length,
        unsentCases: { ...state.unsentCases, [caseId]: alteredCase },
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/damage-case/redux/addPicture.js